function fromNowTimeDirectiveFn($interval, $filter) {
	function link(scope, element, attrs) {
		var time = undefined;
		var interval1Minute = 1000 * 60; // 1 minuto
		var interval1Hour = 1000 * 60 * 60; // 1 hora
		var currentInterval = undefined;
		var filter = $filter('momentDate');
		var stop = undefined;

		/*
		 * actualiza el texto con el formato de fromNow
		 */
		function updateTime() {
			if (angular.isUndefined(time))
				return;
			element.text(filter(time, 'fromNow'));
		}

		/*
		 * se calcula la cantidad e tiempo que ha pasdo de generado el vento si
		 * ha sido menos de una hora se actualiza cada 1 minuto si es mas de una
		 * hora se actualiza cada hora
		 */
		scope.$watch(attrs.fromNowTime, function(value) {
			time = value;
			var val = moment().subtract(time);
			var totHour = moment.duration(val).asHours();
			var inter = (totHour < 1) ? interval1Minute : interval1Hour;
			if (angular.isUndefined(stop)) {
				stop = $interval(updateTime, inter);
				currentInterval = inter;
			} else {
				if (currentInterval != inter) {
					currentInterval = inter;
					$interval.cancel(stop);
					stop = $interval(updateTime, inter);
				}
			}
			updateTime();
		});

		element.bind('$destroy', function() {
			if (!angular.isUndefined(stop))
				$interval.cancel(stop);
		});
	}
	;

	return {
		link : link
	};
}

module.directive('fromNowTime', [ '$interval', '$filter',
		fromNowTimeDirectiveFn ]);